
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Component as VueComponent } from 'vue';
import {
  QueryBuilderConfig, Rule, RuleDefinition, RuleSlotProps,
} from '@/types';
import { isQueryBuilderConfig } from '@/guards';

@Component
export default class QueryBuilderRule extends Vue {
  @Prop({
    required: true,
    validator: param => isQueryBuilderConfig(param),
  }) readonly config!: QueryBuilderConfig

  @Prop() readonly query!: Rule

  get definition(): RuleDefinition {
    const ruleDefinition = this.config
      .rules
      .find(rule => rule.identifier === this.query.identifier);

    if (ruleDefinition) {
      return ruleDefinition;
    }

    throw new Error(`Invalid identifier "${this.query.identifier}": no rule definition available.`);
  }

  get component(): VueComponent | string {
    return this.definition.component;
  }

  get ruleData(): any {
    return this.query.value;
  }

  set ruleData(update: any) {
    this.ruleUpdate(update);
  }

  get ruleSlotProps(): RuleSlotProps {
    return {
      ruleComponent: this.component,
      ruleData: this.query.value,
      ruleIdentifier: this.query.identifier,
      updateRuleData: (ruleData: any) => this.ruleUpdate(ruleData),
    };
  }

  ruleUpdate(update: any) {
    this.$emit(
      'query-update',
      {
        identifier: this.query.identifier,
        value: update,
      } as Rule,
    );
  }

  get showDragHandle(): boolean {
    if (this.config.dragging) {
      return !this.config.dragging.disabled;
    }

    return false;
  }
}
